import { render, staticRenderFns } from "./uiLoader.vue?vue&type=template&id=07b45cc9&scoped=true"
import script from "./uiLoader.vue?vue&type=script&lang=js"
export * from "./uiLoader.vue?vue&type=script&lang=js"
import style0 from "./uiLoader.vue?vue&type=style&index=0&id=07b45cc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b45cc9",
  null
  
)

export default component.exports